var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopChevronWest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  viewBox: "0 0 8 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m1.794 6.8 5.637 5.621a.38.38 0 0 1 0 .534l-.533.536a.38.38 0 0 1-.534 0L.244 7.39a.83.83 0 0 1 0-1.178L6.364.11a.38.38 0 0 1 .534.001l.534.535a.38.38 0 0 1-.001.534z"
})));
export default SvgTiktokDesktopChevronWest;